/**
 * @Description: VIP_V2_OPEN
 * @author XuZiYu
 * @date 2021/12/08 10:02:27
*/
<template>
  <div class="wrapper-open">

    <!--头部-->
    <template v-if="!H5 && headVisible !== '0'">
      <div class="header">
        <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
        <div class="header-main">VIP题库</div>
        <div class="header-share" v-if="shareVisible" @click="openSharePanel"><img src="@/assets/public/icon_fx01.png" alt=""></div>
        <div class="header-right" v-if="!H5" @click="callPhone"><img src="@/assets/vip/icon_customerservice1.png" alt=""></div>
      </div>

      <!--头部占位-->
      <div class="header-pre"></div>
    </template>

    <!--分享框架-->
    <share-ad :detail="shareData">
      <div class="bg">
        <img src="@/assets/vip/picture_viptk01.png" alt=""/>
        <img src="@/assets/vip/picture_viptk02.png" alt=""/>
        <img v-if="openData.ensureFlag" src="@/assets/vip/picture_viptk03.png" alt=""/>
      </div>
      <div class="rule">
        <img class="rule-title" src="@/assets/vip/icon_cjwt.png" alt="">
        <div class="rule-item">
          <div class="rule-item-title">科一&科四VIP课程包含哪些权益，适合哪些用户?</div>
          <div class="rule-item-content">科一&科四理论速成包含精选必做500题、考前秘卷、智能练题、预测通过率多项权益。小车C1、C2的学员都适用，帮助您快速通过科一 &科四考试。</div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">有效期从什么时候开始算?</div>
          <div class="rule-item-content">VIP服务有效期从您购买之日算起，有效期<b>{{openData.effectiveDays}}</b>天</div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">我刚开通VIP为什么消失或者未生效?</div>
          <div class="rule-item-content">请检查是否已经登录了账号，购买成功后,需要登录您的账号才能享受VIP服务。</div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">VIP 购买后可以退款吗?</div>
          <div class="rule-item-content">VIP是虚拟商品，不支持退款哦。</div>
        </div>
        <div class="rule-item" v-if="openData.ensureFlag">
          <div class="rule-item-title">为什么考不过却无法申请现金补偿？</div>
          <div class="rule-item-content">① 考试日期不在VIP有效期内；
            ② 缺考不能申请补偿；
            ③ 科一或科四的成绩分数在60-89分之间，才可申请补偿；
            ④参加公安局车管所举办的驾驶员考试（机动车驾驶员考试）前一天激活保障卡，如当天激活，不能申请补偿；
            ⑤如果提交资料不正确（如：姓名，122网站密码等）会被审核人员驳回且将影响您获得补偿的进度；
            ⑥如果您考试没通过，在还未获取补偿之前再次预约考试，您新的预约会覆盖之前122网站上原来的挂科成绩，审核人员查不到成绩分数，也会导致您申请补偿失败。
          </div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">其他问题及注意事项</div>
          <div class="rule-item-content">购买前请注册/登录App账号，购买成功后，需要登录您购买时的账号才能享受VIP服务。如遇问题，可直接联系右上角帮助中的在线客服或者拨打客服电话咨询，我们会及时为您解答。
          </div>
        </div>
      </div>
    </share-ad>

    <!--底部-->
    <div class="footer">
      <img v-if="openData.ensureFlag"  class="buoy" src="@/assets/vip/icon_sgkbz.png" alt="">
      <span v-if="openData.openMode === 1" class="second">
          限时领取 <b>（分享激活）</b>
      </span>
      <span v-else class="first">
          <b v-if="openData.openMode === 3" class="top">{{openData.pointNum}}斑豆</b>
          <b v-if="openData.openMode === 2" class="top">¥{{openData.payConPrice > 0 ? openData.payConPrice : openData.payOrigPrice}}{{openData.payConPoint ? ` + ${openData.payConPoint}斑豆` : ''}}</b>
          <b v-if="openData.openMode === 2 && openData.payConPrice > 0"
             class="bottom">原价¥{{openData.payOrigPrice}}</b>
      </span>

      <!--车型判断是否显示购买按钮-->
      <template v-if="Number(carType) === 1">
        <van-button v-if="IOS" class="recovery" @click="submit" :loading="loading">恢复购买</van-button>
        <van-button class="fourth" @click="submit" :loading="loading">立即开通</van-button>
      </template>

      <template v-else>
        <div class="btn-none-buy">仅适用于C1/C2学员</div>
      </template>
    </div>

    <!--底部占位-->
    <div class="footer-pre"></div>

    <!--消息弹出框-->
    <ctl-dialog v-model="messageDialog" :loading="loading"/>
  </div>
</template>

<script>
import dialog from '@/components/dialog'
import { Toast, Button } from 'vant'

export default {
    name: 'vipV2Open',
    components: {
        ctlDialog: dialog,
        [Button.name]: Button
    },
    props: ['vipData', 'userInfo'],
    methods: {
        // 返回
        goBack () {
            window.app.returnLastPage && window.app.returnLastPage()
        },
        // 拨打客服电话
        callPhone () {
            window.app.pushCusService && window.app.pushCusService()
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || 'VIP题库'
            // 内容
            let content = '掌握一题=练习多题，轻松搞定科一&科四！'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'question-bank'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/VIPtk.png'
            }

            window.app.share(title, content, shareUrl, imageUrl, pageCode)
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 斑豆开通方式
        beanOpenModel () {
            // 斑豆开通需要登陆
            if (!this.userInfo.userId) {
                window.app.loginUser && window.app.loginUser()
                return
            }

            this.messageDialog = {
                visible: true,
                rightBtnName: '确认',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.$api.bbBeanOpen({ currentUserId: this.userInfo.userId }).then(res => {
                        this.loading = false

                        // 开通成功
                        if (res.result === null && res.status && res.code === '200') {
                            this.$emit('refresh')
                            return
                        }

                        // 斑豆异常处理
                        if (res.message.indexOf('斑豆不足') > -1) {
                            this.messageDialog = {
                                visible: true,
                                rightBtnName: '去做任务',
                                leftBtnName: '取消',
                                leftBtnMethod: () => {
                                    this.messageDialog.visible = false
                                },
                                rightBtnMethod: () => {
                                    // 跳转斑豆任务
                                    window.app.pushBandouCenterPage && window.app.pushBandouCenterPage()
                                },
                                title: '',
                                content: res.message
                            }
                        }

                        // 错误状态码处理
                        if (res.code === '666') {
                            Toast.fail(res.message)
                        }
                    })
                },
                title: '',
                content: '是否确认开通VIP题库？'
            }
        },
        // 金钱开通方式
        moneyOpenModel () {
            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                window.app.loginUser && window.app.loginUser()
                return
            }

            this.loading = true

            this.$api.vipPayOpen({ currentUserId: this.userInfo.userId }).then(res => {
                this.loading = false
                // 正常支付流程
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        window.app.applyPay && window.app.applyPay(res.result, this.openData.productId)
                        return
                    }

                    this.$router.push({
                        name: 'pay',
                        query: {
                            payId: res.result,
                            money: this.openData.payConPrice > 0 ? this.openData.payConPrice : this.openData.payOrigPrice,
                            type: '1',
                            headShow: this.headVisible
                        }
                    })
                    return
                }
                // 错误状态码处理
                if (res.code === '701') {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.$router.push({
                                name: 'vipOrderDetail',
                                query: { id: res.result, headShow: '1' }
                            })
                        },
                        title: '',
                        content: '您有VIP订单未支付'
                    }
                }

                // 斑豆异常处理
                if (res.message.indexOf('斑豆不足') > -1) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去做任务',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转斑豆任务
                            window.app.pushBandouCenterPage && window.app.pushBandouCenterPage()
                        },
                        title: '',
                        content: res.message
                    }
                }

                // 错误状态码处理
                if (res.code === '666') {
                    Toast.fail(res.message)
                }
            })
        },
        // 分享开通方式
        shareOpenModel () {
            // 分享开通需要登陆
            if (!this.userInfo.userId) {
                window.app.loginUser && window.app.loginUser()
                return
            }

            // 标题
            let title = this.openData.title
            // 内容
            let content = this.openData.content
            // 分享链接
            let shareUrl = this.openData.link
            // 图片链接
            let imageUrl = this.openData.image
            // 页面编码
            let pageCode = 'question-bank'

            window.app.share(title, content, shareUrl, imageUrl, pageCode)
        },
        // 开通
        submit () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }

            // 判断是否升级提示
            if (this.vipData.uploadAppFlag) {
                Toast.fail('VIP服务已升级，请升级APP获取更多服务！')
                return
            }

            // 班豆支付
            if (this.openData.openMode === 3) {
                this.beanOpenModel()
            }
            // 金钱支付
            if (this.openData.openMode === 2) {
                this.moneyOpenModel()
            }
            // 分享激活
            if (this.openData.openMode === 1) {
                this.shareOpenModel()
            }
        },
        // 支付回调
        payCallback (v) {
            // 未登录购买刷新数据
            if (Number(v) === 1 && !this.userInfo.userId) {
                this.$emit('refresh')
                return
            }

            // 跳转支付结果页
            this.$router.push({ name: 'payResult', query: { result: v, headShow: '1' } })
        },
        // 分享回调
        shareCallback () {
            // 判断车型 || 是否分享开通模式
            if (Number(this.carType) !== 1 || Number(this.openData.openMode) !== 1) {
                return
            }

            this.loading = true
            this.$api.vipShareOpen({ shareRecordId: this.openData.shareRecordId, times: '1' }).then(res => {
                this.loading = false
                if (res.status) {
                    if (res.result === 0) {
                        this.$emit('refresh')
                    } else {
                        Toast.success('分享成功')
                    }
                }
            })
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'question-bank' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        },
        // 初始化
        init () {
            // 设置vip开通数据
            this.openData = JSON.parse(JSON.stringify(this.vipData.examVipSettingDTO))

            // 设置车型
            this.carType = window.app.getBankCarType ? window.app.getBankCarType() : (window.app.getCarType ? window.app.getCarType() : '1')

            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'

            // 设置app类型
            this.appType = window.app.getAppType ? window.app.getAppType() : (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置分享显示
            this.shareVisible = !!window.app.share

            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'

            // 底部按钮字体布局兼容
            if (this.IOS && this.openData.payConPoint) {
                this.$nextTick(() => {
                    document.querySelectorAll('.top')[0].style.fontSize = '15px'
                    document.querySelectorAll('.bottom')[0].style.fontSize = '14px'
                })
            }

            // 暴露支付回调方法
            window.payCallback = this.payCallback

            // 暴露分享回调方法
            window.shareCallback = this.shareCallback
        }
    },
    mounted () {
        this.init()
    },
    created () {
        this.getSetting()
    },
    data () {
        return {
            // vip开通数据
            openData: {},
            // 分享数据
            shareData: {},
            // 车型默认小车
            carType: '1',
            // loading
            loading: false,
            // 显示分享
            shareVisible: false,
            // 头部显示
            headVisible: '',
            // app类型 1-定制版 2-学时版
            appType: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // h5标记
            H5: false,
            // 弹窗数据
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
  .wrapper-open {
    background: #212528;

    .van-button {
      height: 100%;
      border: none;
    }

    .van-button__loading {
      margin: 0 auto;
      vertical-align: middle;
    }

    .header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      background: #ffffff;

      .header-main {
        font-size: 18px;

        font-weight: bold;
        color: #333333;
      }

      .header-share {
        position: absolute;
        height: 60px;
        display: flex;
        align-items: center;
        right: 50px;
        font-size: 0;
        line-height: 1;

        img {
          width: 24px;
        }
      }

      .header-left, .header-right {
        display: flex;
        padding: 15px 10px;
        font-size: 0;
        line-height: 1;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    .header-pre {
      height: 60px;
    }

    .bg {
      line-height: 1;
      font-size: 0;

      img {
        width: 375px;
      }
    }

    .footer-pre {
      height: 49px;
    }

    .footer {
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 49px;
      border-top: 1px solid #EEEEEE;
      background: #ffffff;
      display: flex;
      justify-content: space-between;

      .buoy{
        width: 110px;
        top: -26px;
        left: 20px;
        position: absolute;
      }
      span {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .first {
        flex-direction: column;
        flex: 1;

        font-weight: 600;
        color: rgba(255, 80, 80, 1);

        .top {
          color: #FF5050;
          font-size: 18px;
        }

        .bottom {
          color: #999999;
          font-size: 14px;
          text-decoration: line-through;
        }
      }

      .second {
        flex: 1;
        font-size: 17px;

        font-weight: bold;
        color: #333333;

        b {
          font-size: 13px;
          font-weight: normal;
        }
      }

      .third {
        width: 80px;
        background: #FFEED2;
        font-size: 18px;

        font-weight: bold;
        color: #D4A36B;
      }

      .fourth {
        border-radius: 0;
        width: 110px;
        background: #F5DDB6;
        font-size: 17px;

        font-weight: bold;
        color: #A86F2F;
      }

      .recovery {
        border-radius: 0;
        width: 110px;
        background: #FFEED2;
        font-size: 17px;

        font-weight: bold;
        color: #A86F2F;
      }
    }

    .rule {
      margin: 10px auto 15px;
      width: 355px;
      background: #3B3E43;
      border-radius: 5px;
      padding-bottom: 20px;

      .rule-title {
        display: block;
        margin: 0 auto 20px;
        width: 120px;
        height: 30px;
      }

      .rule-item {
        padding: 0 15px;

        .rule-item-title {
          background: url("~@/assets/vip/icon_wt.png") no-repeat left 2px;
          background-size: 16px;

          padding-left: 26px;
          line-height: 22px;
          font-size: 15px;
          font-weight: 600;
          color: #FFFFFF;
        }

        .rule-item-content {
          word-break: break-word;
          white-space: pre-line;
          margin-top: 10px;
          padding-left: 26px;
          font-size: 12px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 21px;

          b{
            color: #FF5050;
          }
        }
      }

      .rule-item + .rule-item {
        margin-top: 20px;
      }
    }

    .btn-none-buy{
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      font-size: 15px;
      font-weight: bold;
      color: #999999;
      background: #F0F0F0;
    }
  }
</style>
